export default {
  POLI: 'POLi',
  BPAY: 'BPay',
  PAYID: 'PayID',
};
